/**
 * Pure RBAC helpers (used by UI and tests). Firestore rules are the source of truth for enforcement.
 */

export function normalizeRole(raw) {
  if (raw == null || raw === "") return "student";
  const s = String(raw).trim().toLowerCase();
  if (s === "admin" || s === "administrator") return "admin";
  if (s === "instructor" || s === "teacher") return "instructor";
  if (s === "student") return "student";
  return s;
}

export function isAdminRole(role) {
  return normalizeRole(role) === "admin";
}

/** Authoring / curriculum / chat ops are admin-only (instructors no longer author). */
export function canAuthorCurriculum(role) {
  return isAdminRole(role);
}

export function canAccessInstructorStudio(role) {
  return isAdminRole(role);
}
